import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';
import logo from '../assets/logo-kinshasa.png';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(username, password);
      if (result.success && result.data) {
        // Stocker le token et les données utilisateur
        localStorage.setItem('token', result.data.token);
        localStorage.setItem('user', JSON.stringify(result.data.user));
        localStorage.setItem('isAuthenticated', 'true');
        
        onLogin(result.data.user);
        navigate('/');
      } else {
        setError(result.message || 'Nom d\'utilisateur ou mot de passe incorrect');
        setPassword('');
      }
    } catch (err) {
      setError('Erreur de connexion : ' + (err.response?.data?.message || err.message));
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary to-primary-dark min-h-screen flex items-center justify-center font-sans">
      <div className="bg-cardBg rounded-2xl shadow-2xl p-10 w-full max-w-md animate-scale-in">
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Logo" className="w-24 h-24 object-contain" />
        </div>

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-text mb-2">IdTrack</h1>
          <p className="text-text-light text-sm">Identification des Agents Terrain</p>
          <p className="text-text-light text-xs mt-1">
            Ministère Provincial de Transport et Mobilité Urbaine - Kinshasa
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-text mb-2">
              <i className="fas fa-user mr-1"></i> Nom d'utilisateur
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Entrez votre nom d'utilisateur"
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
              autoFocus
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium text-text mb-2">
              <i className="fas fa-lock mr-1"></i> Mot de passe
            </label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Entrez votre mot de passe"
                className="w-full px-4 py-3 pr-12 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-primary focus:outline-none transition-colors"
                aria-label={showPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'}
              >
                <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-white py-3 rounded-lg font-medium hover:bg-primary-dark transition-all transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2"></i> Connexion...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt mr-2"></i> Se Connecter
              </>
            )}
          </button>
        </form>

        {error && (
          <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm animate-slide-down">
            <i className="fas fa-exclamation-circle mr-2"></i>
            {error}
          </div>
        )}

        <div className="mt-8 text-center text-xs text-text-light">
          <p>
            <i className="fas fa-shield-alt mr-1"></i> Accès sécurisé et crypté
          </p>
          <p className="mt-2">© 2025 MPTMU Kinshasa - Tous droits réservés</p>
        </div>
      </div>
    </div>
  );
};

export default Login;

